import baseTransitions from './styles/base.module.css';
import fadeTransitions from './styles/fade.module.css';
import slideDownTransitions from './styles/slide-down.module.css';
import slideUpTransitions from './styles/slide-up.module.css';

export default {
  slideDown: {
    transitions: slideDownTransitions,
    defaultOut: slideUpTransitions,
    duration: 300,
  },
  slideUp: {
    transitions: slideUpTransitions,
    defaultOut: slideDownTransitions,
    duration: 300,
  },
  fade: {
    transitions: fadeTransitions,
    defaultOut: fadeTransitions,
    duration: 300,
  },
  base: {
    transitions: baseTransitions,
  },
};
